import React from 'react'

import VideoPallet from '../../../../utils/VideoPallet'

function FirstSection() {
  // Ganti VIDEO_ID dengan ID video YouTube yang diinginkan
  const VIDEO_ID = "38T76nUhdSk";

  return (
   <div className="min-h-screen relative flex items-center justify-center overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="relative w-full h-full object-contain">
          <iframe
            src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&controls=0&mute=1&loop=1&playlist=${VIDEO_ID}&showinfo=0&rel=0&enablejsapi=1&version=3&playerapiid=ytplayer`}
            title="Background video"
            className="absolute w-[300%] h-[300%] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
          />
        </div>
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/70" />
      
      {/* Main content */}
      <div className="relative z-10 container mx-auto px-4">
        <div className="relative h-72 flex justify-center items-center mt-20">
          <div className="text-center animate-bounce">
            <h1 className="text-5xl md:text-6xl font-black mb-2 uppercase transition-colors duration-300 hover:cursor-pointer">
              Produk Terbaik
            </h1>
            <h2 className="text-2xl md:text-4xl font-black uppercase transition-colors duration-300 hover:cursor-pointer">
              kami bekerja sama dengan L'Oreal untuk menciptakan produk berkualitas dan hasil yang memuaskan anda
            </h2>
          </div>
        </div>
      </div>

      <style>{`
        h1, h2 {
          background: linear-gradient(
            to bottom,
            #A75B3B 0%,
            #ffffff 50%,
            #ffffff 100%
          );
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
          letter-spacing: 0.05em;
          font-family: "Arial Black", sans-serif;
        }

        h1:hover, h2:hover {
          background: linear-gradient(
            to bottom,
            #ffffff 0%,
            #ffd700 50%,
            #daa520 100%
          );
          -webkit-background-clip: text;
          background-clip: text;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fadeIn 1.5s ease-out forwards;
        }

        video::-webkit-media-controls {
          display: none;
        }
      `}</style>
    </div>
  )
}

export default FirstSection